import React from "react";
import { View, StyleSheet } from "@react-pdf/renderer";
import DetailPdfTableHeader from "./DetailPdfTableHeader";
import DetailPdfTableBlankSpace from "./DetailPdfTableBlankSpace";
import DetailPdfTableFooter from "./DetailPdfTableFooter";
import DetailPdfTableRow from "./DetailPdfTableRow";

// const tableRowsCount = 11;

const styles = StyleSheet.create({
  tableContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: 24,
    borderWidth: 1,
    borderColor: "#40A7FE",
  },
});

const DetailPdfItemsTable = ({ detail }) => (
  <View style={styles.tableContainer}>
    <DetailPdfTableHeader />
    <DetailPdfTableRow items={detail.workedHoursDetail} />
    <DetailPdfTableBlankSpace rowsCount={detail.workedHoursDetail} />
    <DetailPdfTableFooter items={detail} />
  </View>
);

export default DetailPdfItemsTable;
